import { render } from "./userNewbill.vue?vue&type=template&id=d060b406&scoped=true"
import script from "./userNewbill.vue?vue&type=script&lang=js"
export * from "./userNewbill.vue?vue&type=script&lang=js"

import "./userNewbill.vue?vue&type=style&index=0&id=d060b406&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d060b406"]])

export default __exports__